import { __rest } from '../../node_modules/tslib/tslib.es6.js';
import { jsx } from 'react/jsx-runtime';
import { Component } from 'react';
import cns from '../../node_modules/classnames/index.js';

//  Non trasformare in pure function
// eslint-disable-next-line react/prefer-stateless-function
class Option extends Component {
    render() {
        const _a = this.props, { children, additionalData, className, notifica, isSelected, value } = _a, others = __rest(_a, ["children", "additionalData", "className", "notifica", "isSelected", "value"]);
        const classes = cns('select__option', {
            'select__option--selected': isSelected === true,
        }, className);
        const valueStr = value ? `${value}` : undefined;
        return (jsx("li", Object.assign({ className: classes, role: "presentation", onClick: (evt) => notifica(evt, value, additionalData, true), value: valueStr }, others, { children: children })));
    }
}
Option.displayName = 'Select.Option';
Option.defaultProps = {
    additionalData: null,
    className: '',
    children: null,
    isSelected: false,
    notifica: null,
    value: null,
};

export { Option as default };
